export default __webpack_public_path__ + "static/media/1647.4f181b3b.png";